<template>
        <div class="wrapper">
       <!-- <article class="title">
        <h1 class="hi">SAMSUNG Samsung-EcoPackage Privacy Notice </h1>
        <p>Effective Date: March 27, 2020</p>
        <p>Samsung Electronics Co., Ltd., along with our affiliates and subsidiaries (collectively, “Samsung”) respect your concerns about privacy. This Samsung-EcoPackage Privacy Notice applies to the personal information we obtain through Samsung-EcoPackage (“SEP”). It does not apply to information collected by other apps, websites or services provided by Samsung. </p>
        <p>This Privacy Notice provides information about how may collect, use and share your personal information in connection with SEP. Our Privacy Policy at <a class="link" href="https://account.samsung.com/membership/pp">https://account.samsung.com/membership/pp</a> (“Samsung Privacy Policy for the U.S.”) will also apply to your use of SEP, and should be read in conjunction with this Privacy Notice. The Samsung Privacy Policy for the U.S. provides additional information about our personal information practices, including how to contact us. In the event any portion of this Privacy Notice conflicts with the Samsung Privacy Policy for the U.S. the relevant provisions of this Privacy Notice will govern.</p>
        </article>
        
        <p></p>
        <ol class ="info-list">
          <li class="info-item-0">
            <h2>Information We Obtain</h2>
            <p>Through SEP, we may obtain information about you in various ways. The types of personal information we may obtain include:</p>
            <p>•	Geolocation data.  With your permission, we may receive your device’s precise geolocation and other information related to your location through GPS, Bluetooth and WiFi signals, and other technologies to provide you with information about the weather for the region you request. Your device will notify you when SEP attempts to collect your precise geolocation.  Please note that if you do not allow SEP to collect your precise geolocation, you may not be able to use all of the features of SEP.</p>      
            <p>•	Device and app information  We collect information through automated means about your SEP-enabled devices, such as device model, OS version, device configurations and settings, IP address, device identifiers and other unique identifiers.  In addition, we may obtain information about how, when and for how long you use your SEP-enabled devices, including your use of SEP and other Samsung and third-party apps and services on your devices (such as a list of apps on your devices,  the websites you visit and the searches you run).</p>
            </li>
          <li class="info-item-1">
             <h2>How We Use the Information We Obtain</h2>
             <ol class="two-depth">
                <li>
                  <p>We may use the information we obtain through SEP  to:</p>
                    <ul class="two-depth">
                      <li>•	provide you with SEP;</li>
                      <li>•	deliver advertising, including customized advertisements, sponsored content, and promotional communications (such as through Samsung Ads, more details available at <a class="link" href="https://www.samsung.com/us/account/privacy-policy/samsungads">https://www.samsung.com/us/account/privacy-policy/samsungads</a></li>
                      <li>•	allow you to interact with and use participating third-party apps and services;</li>
                      <li>•	protect against, identify and prevent fraud and other criminal activity, claims and other liabilities; </li>
                    </ul>
                </li>
             </ol>
          </li>
          <li class="info-item-2">
             <h2>Information Sharing</h2>
              <p>We may share your personal information with our subsidiaries and affiliates and with service providers who perform services for us.  We do not authorize our service providers to use or disclose the information except as necessary to perform services on our behalf or to comply with legal requirements.  In addition, we may share your personal information with our business partners, such as wireless carriers, as well as third parties who operate apps and services that connect with certain of the Services.</p>
              <p>We may share personal information we collect through the Services if you ask us to do so or otherwise with your consent.  We also may disclose information about you in other circumstances, including (1) if we are required to do so by law or legal process, (2) to law enforcement authorities or other government officials, (3) when we believe disclosure is necessary or appropriate to prevent physical harm or financial loss, or in connection with an investigation of suspected or actual fraudulent or illegal activity, and (4) in the event we may or do sell or transfer all or a portion of our business or assets (including in the event of a merger, acquisition, joint venture, reorganization, divestiture, dissolution or liquidation). </p>
          </li>
          <li class="info-item-3">
            <h2>Updates to This Privacy Notice</h2>
            <p>This Privacy Notice may be updated periodically to reflect changes in our personal information practices with respect to SEP or changes in the applicable law. We will indicate at the top of this Privacy Notice when it was most recently updated.</p>
          </li>
        </ol> -->
        </div>
</template>

<script>


export default {
  components: {
  },
  data() {
    return {
     };
  },
  created() {
   this.$router.push({ name: 'Home' });

  },
  methods: {

  }
};
</script>

<style scoped>
.wrapper {
  background-color: black;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
  margin:auto;
}
/* .p{
  margin-block-start:1em;
  margin-block-end:1em;
} */
.hi{
  margin-top: 128px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
/* li{
  margin-top:4.453125vw;
} */
.link{
    cursor: pointer;
}
table{
  border-collapse:collapse;
  width:100%;
  text-align:center;
  margin-top:20px;
  margin-bottom:20px;
}
td,th{
  padding:0;
}
td,th{
  border: 1px solid #FFFFFF;
}
.info-item-0, .info-item-1,.info-item-2,.info-item-3,.info-item-4,.info-item-5,.info-item-6,.info-item-7,.info-item-8,.info-item-9,.info-item-10{
  margin-top:30px;
}
.info-item-2{
  margin-top:20px;
}
table.type-short{
  width:365px;
}
table.type-wide{
  width:920px;
}
ul,ol{
  list-style:none;
}
dl,ul,ol,dt,dd,blockquote,p,h1,h2,h3,h4,h5,h6{
  padding:0;
  margin:0;
  text-align:left;
}
tbody{
  display:table-row-group;
  vertical-align:middle;
}
@media (max-width: 1024px) {
  .wrapper{
    max-width: 83.33vw;
    margin:auto;
  }
 .hi{
  margin-top: 70px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
table.type-wide{
  max-width: 83.33vw;
}
table.type-short{
  max-width: 83.33vw;
}
table{
  margin-top:10px;
  margin-bottom:10px;
}
}
</style>


    
    
   
   
   
    
   